export const dark_red = "#770312";
export const light_red = "#BC041C";
export const pink = "#bc041c4a";//"#F29E9D";
